import { Injectable } from '@angular/core';
import { HttpClient,  HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, ReplaySubject, Subject, throwError } from 'rxjs';
import { catchError, retry} from 'rxjs/operators';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service'


@Injectable({
  providedIn: 'root'
})

export class UsersService {
  error_message: any;
  constructor(private http: HttpClient, private title: Title, private meta: Meta, private CookieService: CookieService) { }

  options = { headers: new HttpHeaders ({ 'Content-Type': 'application/json' }) }

  bg_id = this.CookieService.get('bg_id');

  userSubscriptionDetails(userId: string): Observable<any> {
    return this.http.get<any>(environment.apiURL+"users/tvod_library_details?ext_user_id="+userId+"&region=any&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
  }


  emailLogin(userLogin: any): Observable<any> {
    var signin_params = {};
    signin_params["email"] = userLogin.controls.login_email.value,
    signin_params["password"] = userLogin.controls.login_email_password.value;
    return this.http.post<any>(environment.apiURL+"cms_users/login?auth_token="+environment.authtoken, JSON.stringify(signin_params), this.options)
    // return this.http.post<any>("http://164.52.216.90:3000/users/login", JSON.stringify(signin_params), this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
     
  }

  userDetails(sessionId: string): Observable<any> {
    return this.http.get<any>(environment.apiURL+"admin_user/"+sessionId+"?auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
  }

  // http://164.52.216.90/get_all_system_catalog_info?auth_token=Vzu3T7rUqFyhGorWSKKy&bg_id=699806069
  getSystemCatalogInfo(bg_id: string): Observable<any> {
    return this.http.get<any>(`${environment.apiURL}/get_all_system_catalog_info?auth_token=${environment.authtoken}&bg_id=${bg_id}`)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
  }
  

  userSignout(session_id: any) {
    var signout_params = {}
    signout_params["user_session_id"] = localStorage.getItem("user_session_id")
    signout_params["active_user_id"] = localStorage.getItem("user_id")   

    return this.http.get<any>(environment.apiURL+"cms_users/logout?active_session="+session_id+"&bg_id="+this.bg_id+environment.authtoken,this.options)
    //  return this.http.post<any>("http://164.52.216.90:3000/users/logout.json", JSON.stringify(signout_params), this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
  }

  forgotPassword(data): Observable<any>{
    return this.http.put<any>(environment.apiURL+"/cms_users/update_password?auth_token="+environment.authtoken, JSON.stringify(data), this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
  }

  resetPassword(data): Observable<any>{
    return this.http.put<any>(environment.apiURL+"/cms_users/change_password?auth_token="+environment.authtoken+"&active_session="+active_session_details.active_session, JSON.stringify(data), this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
  }

  setUserLocalStorage(user: {}) {
    localStorage.setItem('user_session_id', user['user_session_id']);
    localStorage.setItem('user_name', user['user_name']);
    localStorage.setItem('user_email', user['user_email']);
    localStorage.setItem('user_cms_token', user['user_cms_token']);
    localStorage.setItem('user_privileges', JSON.stringify(user['user_privileges']))
    localStorage.setItem('user_role', user['user_role'])

    active_session_details['active_session'] = user['user_session_id']

    this.CookieService.set('user_session_id', user['user_session_id'])
    this.CookieService.set('user_name', user['user_name'])
    this.CookieService.set('user_email', user['user_email'])
    this.CookieService.set('user_cms_token', user['user_cms_token'])
    this.CookieService.set('user_privileges', JSON.stringify(user['user_privileges']))
    this.CookieService.set('service_brought', user['service_brought'])
    this.CookieService.set('user_role', user['user_role'])
    this.CookieService.set('business_group_id', user['business_group_id'] ? user['business_group_id'] : '')
    // bg_tenants comes from the login response as an array of tenant ids.
    // Store the single tenant id string the app expects, and never persist "undefined".
    const tenant_id = Array.isArray(user['tenant_ids']) ? user['tenant_ids'][0] : user['tenant_ids'];
    this.CookieService.set('tenant_ids', tenant_id ? tenant_id : '')


    if(user['user_role'] === 'cms_manager'){
      this.CookieService.set('bg_id', user['cms_bg_id'] )
    }else{
      this.CookieService.set('loggedIn_bg', user['transcode_bg_id'])
    }




  }


  removeUserLocalStorage() {
    localStorage.removeItem('user_session_id');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_cms_token');
    localStorage.removeItem('user_privileges')
    localStorage.removeItem('user_role')

    this.CookieService.delete('user_session_id')
    this.CookieService.delete('user_name');
    this.CookieService.delete('user_email');
    this.CookieService.delete('user_cms_token');
    this.CookieService.delete('user_privileges')
    this.CookieService.delete('userPrivilegesObj')
    this.CookieService.delete('user_role')
    this.CookieService.delete('bg_id')
    this.CookieService.delete('bg_authtoken')
    this.CookieService.delete('bg_user_name')
    this.CookieService.delete('service_brought')
    this.CookieService.delete('loggedIn_bg')
    this.CookieService.delete('business_group_id')
    this.CookieService.delete('tenant_ids')
  }

  getUserLoginStatus()
  {
    if(localStorage.getItem("user_session_id"))
    {
      return true;
    }
    else
    {
      return false;
    }
  }
   
  getUsers(): Observable<any> { 
    return this.http.get<any>("http://164.52.216.90:3000/api/v1/users/view_all?active_session="+localStorage.getItem('user_session_id')+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.handleError)
     );
  }

  
  
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    //console.log(error);

    if (error.error instanceof ErrorEvent) {
       //console.log('client-side error')
      errorMessage = `Error: ${error.error.message}`;
    } else {
      //console.log('server-side error');
      //console.log(error);
      if(error.error.error.error_code){
        this.error_message = {
          server_error_code: error.error.error.error_code,
          server_error_messsage:error.error.error.error_message
        }
      }
      else if(error.error.error) {
        //console.log("error.error"+error.error)
        this.error_message = {
          server_error_code: error.error.error.code,
          server_error_messsage: error.error.error.message ? error.error.error.message : error.error.error
        }
      }
      else {
        //console.log("no:");
        this.error_message = {
          server_error_code: error.status,
          server_error_messsage: error.message
        }
      }

      //errorMessage = `server_error message: ${error.error.error.message}+Error Code: ${error.status}+Message: ${error.message}`;
      errorMessage = this.error_message;
    }
    return throwError(errorMessage);
  }

}

export const active_session_details = {
  active_session: localStorage.getItem('user_session_id')
};

